import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { PRODUCT_CUSTOMER_PHOTOS_REVIEWS_MIN } from 'data-hooks/queries';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';
const useProductCustomerPhotosReviewsMin = () => {
  const $ = _c(7);
  const {
    variables,
    skip
  } = usePDPApolloQueryVariables();
  let t0;
  if ($[0] !== skip || $[1] !== variables) {
    t0 = {
      variables,
      skip
    };
    $[0] = skip;
    $[1] = variables;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    data: responseData,
    loading,
    error
  } = useSuspenseQuery(PRODUCT_CUSTOMER_PHOTOS_REVIEWS_MIN, t0);
  const data = responseData?.productCustomerPhotosAndReviewsMin;
  const t1 = loading && !data;
  let t2;
  if ($[3] !== data || $[4] !== error || $[5] !== t1) {
    t2 = {
      data,
      error,
      loading: t1
    };
    $[3] = data;
    $[4] = error;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useProductCustomerPhotosReviewsMin;